import React from 'react';
import Button from 'components/UI/V3/Button/Button';
import styles from './MobileWizardFooter.module.scss';

interface MobileWizardFooterProps {
    label?: string;
    disabled?: boolean;
    onClick: () => void;
}

export const MobileWizardFooter: React.FC<MobileWizardFooterProps> = ({
    label = 'Continue',
    disabled = false,
    onClick
}) => {
    return (
        <div className={styles.footer}>
            <Button
                size="large"
                label={label}
                disabled={disabled}
                noColorOnDisabled
                className={styles.button}
                onClick={onClick}
            />
        </div>
    );
};
